import { AccordionBodyItem } from 'component/Accordion';
import React from 'react';

export const ReporterName = (props) => {
  const { formData } = props;

  return (
    <AccordionBodyItem
      accordionSubId={(
        <div>
          <span>1.9</span>
          <span className="star">*</span>
        </div>
      )}
      titleUA="Звіт надав"
      titleEN="Submitted the report"
      children={(
        <span className="no-wrap">
          {formData?.info?.general?.reporter_name}
        </span>
      )}
    />
  );
};
